import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zendesk = defineConnector({
  identifier: "zendesk",
  name: "Zendesk",
  tagLine: "Customer service and support",
  logo,
  protocol: "http",
  tags: ["featured", "it", "productivity", "communication"],
  defaultUrlPattern: () => "https://.*\\.zendesk\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: `${app.config.email}/token`,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Zendesk admin panel. Navigate to **Admin Center > Apps and integrations > Zendesk API > Zendesk API settings** and enable token access. Then create a new API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Zendesk domain",
          required: true,
          placeholder: "yourcompany",
          target: { kind: "configuration", field: "domain" },
          helperText: "Your Zendesk domain (e.g., yourcompany.zendesk.com)",
        },
        {
          kind: "input",
          label: "Email address",
          required: true,
          target: { kind: "configuration", field: "email" },
          helperText: "The email address associated with your Zendesk account",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/users/me.json`,
  },
  publicEnvVars: ({ domain, email }) => ({
    ZENDESK_URL: domain ? `https://${domain}` : "",
    ZENDESK_EMAIL: email || "",
  }),
});
